__turbopack_context__.v({
  "checkbox": "CollapsibleCodeContent-module__fUbD7G__checkbox",
  "code": "CollapsibleCodeContent-module__fUbD7G__code",
  "codeBlock": "CollapsibleCodeContent-module__fUbD7G__codeBlock",
  "collapseLabel": "CollapsibleCodeContent-module__fUbD7G__collapseLabel",
  "container": "CollapsibleCodeContent-module__fUbD7G__container",
  "expandLabel": "CollapsibleCodeContent-module__fUbD7G__expandLabel",
  "fileRefs": "CollapsibleCodeContent-module__fUbD7G__fileRefs",
  "frame": "CollapsibleCodeContent-module__fUbD7G__frame",
  "toggle": "CollapsibleCodeContent-module__fUbD7G__toggle",
});
